import { monthName } from '../../lib/format';
import { useApi } from '../../lib/useApi';
import { useKanzlei } from '../context';
import type { OverviewResponse } from './types';
import { isGap } from './useBelegeOverview';

// Kennzahl „Belege … offen“: FiBu-Mandanten, bei denen im Fokus-Monat Belege fehlen.
// Wer nur Lohn macht, sieht sie nicht.
export function BelegeKpi() {
  const { me } = useKanzlei();
  const res = useApi<OverviewResponse>('/api/kanzlei/belege/overview', { live: ['belege', 'fristen'] });
  if (!res.data) return null;
  const fibu = res.data.clients.filter((c) => c.fibu);
  if (!me.user.isAdmin && !fibu.length) return null;
  const gaps = fibu.filter((c) => isGap(c.focus.state)).length;
  const first = fibu[0]?.focus;
  // alle im selben Monat: den Monat nennen
  const same = first && fibu.every((c) => c.focus.month === first.month && c.focus.year === first.year) ? first : null;
  const t = res.data.today;
  const forUstva = same && (same.year !== t.year || same.month !== t.month);
  return (
    <div className="card">
      <div className="kl">Belege {same ? `${monthName(same.month)} ` : ''}offen</div>
      <div className="kv num">{gaps}</div>
      <div className="ks">Mandanten mit Lücken{forUstva ? ' · für die UStVA' : ''}</div>
    </div>
  );
}
